import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ObituaryService } from '../obituary.service';
import { ObituaryApi } from '../obituary.api';
import { DeadViewComponent } from '../dead-view/dead-view.component';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { Toaster } from '@app/services/toaster/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { iDeath } from '../death.interface';
import { MetaService } from '@app/services/meta.service';
import { ErrorBoxComponent } from '@app/shared/components/error-box/error-box.component';
import { AdPushComponent } from '@app/shared/components/ads/ad-push/ad-push.component';

@Component({
	selector: 'app-dead-page',
	standalone: true,
	imports: [
		SharedModule,
		DeadViewComponent,
		ErrorBoxComponent,
		AdPushComponent,
	],
	providers: [
		ObituaryService,
		ObituaryApi,
	],
	templateUrl: './dead-page.component.html',
	styleUrl: './dead-page.component.scss'
})
export class DeadPageComponent implements OnInit {
	public loading:boolean = false;
	public deadName:string = "...";
	public deadSub:string = "...descanse em paz";
	public death?:iDeath;
	public errorBox:boolean = false;

	constructor (
		private route: ActivatedRoute,
		public nav: NavigationService,
		private meta: MetaService,
		private toast: Toaster,
		private service: ObituaryService,
	) { }

	ngOnInit(): void {
		this.loadHash();
	}

	private updateMeta() {
		this.meta.setDead(this.death!);
	}

	private loadHash() {
		const h = this.route.snapshot.paramMap.get("hash");
		if(!h) {
			this.toast.error("Não foi possível identificar o hash!");
			this.nav.goHome();
			return;
		}
		const hPieces = h.split("-");
		const deadId = +hPieces[0];
		this.loadDead(deadId);
	}

	private loadDead(deadId:number) {
		this.loading = true;
		this.service.getDeath(deadId)
			.subscribe({
				next: (rs) => {
					this.deadName = rs.name;
					this.deadSub = `${rs.age} anos, ${rs.winners} acertadores`;
					this.death = rs;
					this.loading = false;
					this.updateMeta();
				},
				error: (err) => this.errorDeal(err),
			});
	}

	private errorDeal(err: any) {
		console.error("oh no", err);
		this.loading = false;
		this.deadName = "Erro!";
		this.deadSub = "Presunto não encontrado!";
		this.errorBox = true;
	}


}
